(() => {
  function init(scope=document){
    scope.querySelectorAll('[data-lds-ghost]').forEach(root=>{
      if(root.dataset.initialized)return;
      root.dataset.initialized='true';
      const video=root.querySelector('[data-lds-ghost-video]');
      const poster=root.querySelector('[data-lds-ghost-poster]');
      const toggle=root.querySelector('[data-lds-ghost-toggle]');
      const motion=matchMedia('(prefers-reduced-motion: reduce)');
      const saveData=Boolean(navigator.connection&&navigator.connection.saveData);
      let userPaused=false,loaded=false,visible=false;
      function setLabel(){toggle.textContent=video.paused?root.dataset.playLabel:root.dataset.pauseLabel;}
      function load(){
        if(loaded)return;
        video.querySelectorAll('source[data-src]').forEach(source=>source.src=source.dataset.src);
        video.muted=true;
        video.load();
        loaded=true;
      }
      function play(){
        load();video.hidden=false;
        const playing=video.play();
        if(playing&&playing.catch)playing.catch(()=>{video.hidden=true;poster.style.visibility='visible';setLabel();});
      }
      toggle.hidden=false;
      toggle.addEventListener('click',()=>{
        if(video.paused){userPaused=false;play();}
        else{userPaused=true;video.pause();}
      });
      video.addEventListener('playing',()=>{poster.style.visibility='hidden';setLabel();});
      video.addEventListener('pause',setLabel);
      video.addEventListener('error',()=>{video.hidden=true;poster.style.visibility='visible';setLabel();});
      motion.addEventListener('change',()=>{
        if(motion.matches){video.pause();video.hidden=true;poster.style.visibility='visible';}
        else if(visible&&!userPaused&&!saveData)play();
      });
      if('IntersectionObserver'in window){
        const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
          visible=entry.isIntersecting;
          if(visible&&!motion.matches&&!saveData&&!userPaused)play();
          else if(!visible)video.pause();
        }),{threshold:.05});
        observer.observe(root);
      }else if(!motion.matches&&!saveData)play();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-lds-ghost-video]').forEach(video=>video.pause()));
})();
